<!DOCTYPE html>
<!DOCTYPE html>
<!-- Created component by rajendra - Date: 14-11-2022 HATDEV-24149 (Create internal tabs UI and switching UX to render the children) -->
<div class="fortune-sub-wrraper">
  @if (userFortuneMapData$ | async; as userData) {
    <mat-tab-group
      #matTabGroup
      [selectedIndex]="currentTab"
      class="fortune-mat-tab"
      >
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" [ngClass]="{ 'fortune-subtab': subTab === 0 }"
            >{{ "map.Map" | translate }}</span
            >
          </ng-template>
          <div class="map-wraaper">
            <div class="titles-block">
              <div class="title-networth">
                <h2>{{ "map.Millionaire" | translate }}</h2>
                <div class="assetvalue">
                  <div class="worth">
                    <span class="networth">{{ "map.net_worth" | translate }}</span>
                    <span class="currency"> ({{ "map.USD" | translate }})</span>
                  </div>
                  <div>
                    <span class="netvalue">${{ netWorth }}</span>
                  </div>
                </div>
              </div>
              <p [innerHTML]="'map.supportive' | translate"></p>
            </div>
            <div class="map-canvas">
              <div
                class="levels-wrapper"
                [style.background-image]="'url(' + imageUrl + ')'"
                >
                <div
                  class="level level-1"
                  (click)="changeImg('property', userData, 'real_estate')"
                  >
                  <img
                    src="{{ userData.real_estate.image_url }}"
                    alt=""
                    class="property-img"
                    />
                    @if (userData['real_estate'].change_status == true) {
                      <ng-lottie
                        height="14.5vh"
                        width="100%"
                        [options]="options"
                        class="hand-tap hand-tap-one"
                      ></ng-lottie>
                    }
                  </div>
                  <div
                    class="level level-2"
                    (click)="changeImg('garage', userData, 'transport')"
                    >
                    <img
                      src="{{ userData.transport.image_url }}"
                      alt=""
                      class="garage-img"
                      />
                      @if (userData['transport'].change_status == true) {
                        <ng-lottie
                          height="14.5vh"
                          width="100%"
                          [options]="options"
                          class="hand-tap hand-tap-two"
                        ></ng-lottie>
                      }
                    </div>
                    <div
                      class="level level-3"
                      (click)="changeImg('bucketList', userData, 'lifestyle')"
                      >
                      <img
                        src="{{ userData.lifestyle.image_url }}"
                        alt=""
                        class="bucketList-img"
                        />
                        @if (userData['lifestyle'].change_status == true) {
                          <ng-lottie
                            height="14.5vh"
                            width="100%"
                            [options]="options"
                            class="hand-tap hand-tap-three"
                          ></ng-lottie>
                        }
                      </div>
                      <div
                        class="level level-4"
                        (click)="changeImg('holiday', userData, 'holiday')"
                        >
                        <img
                          src="{{ userData.holiday.image_url }}"
                          alt=""
                          class="holiday-img"
                          />
                          @if (userData['holiday'].change_status == true) {
                            <ng-lottie
                              height="14.5vh"
                              width="100%"
                              [options]="options"
                              class="hand-tap hand-tap-four"
                            ></ng-lottie>
                          }
                        </div>
                        <!-- <div class="level level-5">
                        <div class="dot">
                          level 5
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
                <!-- content -->
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <span class="tab-label" [ngClass]="{ 'fortune-subtab': subTab === 1 }">
                    {{ "Lifestyle.lifestyle" | translate }}</span
                    >
                  </ng-template>
                  <app-fortune-lifestyle [lfTabIndex]="selectedTab"></app-fortune-lifestyle>
                  <!-- content -->
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <span class="tab-label" [ngClass]="{ 'fortune-subtab': subTab === 2 }">
                      {{ "discovery.Discover" | translate }}</span
                      >
                    </ng-template>
                    @if (!(currentTab === 1)) {
                      <p></p>
                    }
                    <app-fortune-discover></app-fortune-discover>
                    <!-- content -->
                  </mat-tab>
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <span
                        class="tab-label"
                        [ngClass]="{ 'community-subtab': subTab === 3 }"
                        >
                        Missions</span
                        >
                      </ng-template>
                      <app-fortune-missions></app-fortune-missions>
                      <!-- content -->
                    </mat-tab>
                  </mat-tab-group>
                }
              </div>
